import {I18n} from "react-redux-i18n";
import _ from "../../utils/ObjectUtils";
import React from "react";
import FileUploader from "./FileUploader";
import axios from "axios";

const ImgUploader = ({
    image,
    viewMode,
    handleImageUploaded,
    handleWrongImageFormat,
    labelStyle
}) => {
    let imageTypes = ["jpg", "jpeg", "png"];
    let allowedFiles = ".jpg, .jpeg, .png";

    return createImageUploadPlaceholder(image, allowedFiles, viewMode, handleImageUploaded, handleWrongImageFormat, imageTypes, labelStyle)
};

function createImageUploadPlaceholder(image, allowedFiles, viewMode, handleImageUploaded, handleWrongImageFormat, imageTypes, labelStyle) {
    return <>
        {!viewMode &&
        <FileUploader
            allowedExtensions = {imageTypes}
            onFileUploaded={handleImageUploaded}
            handleWrongFileFormat={handleWrongImageFormat}
            allowedFiles={allowedFiles}
            placeholder={I18n.t("fields.imgUploader.uploadImg")}
            style={labelStyle}
            error={image.error}
        />
        }
        {(image.imagePreview || image.value) &&
        <div className="row text-center" style={{position: "relative"}}>
            <img
                alt={I18n.t("subForms.file.image")}
                src={!_.isNil(image.imagePreview) ? image.imagePreview : image.value ? axios.defaults.baseURL + image.value : null}
                className="upload-photo-placeholder"
            />
        </div>
        }
    </>
}

export default ImgUploader;